var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 64,
    viewBox: "0 0 104 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 103,
    height: 63,
    rx: 4.5,
    stroke: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.6605 54L83.3679 47.3706L89.0483 54H96L86.8032 43.6765L96 33.3531H89.1565L83.4761 40.0397L77.8634 33.3531H70.9117L80.0409 43.7338L70.9252 53.9857V49.2463H59.6997V46.0677H70.6412V41.4429H59.6997V38.2356H70.9252V33.4963H54.4251V54H77.6605ZM85.7753 30.5181L90.7659 16.1139V30.5181H96V10H87.8581L83.5032 22.7862L79.1888 10H70.9117V30.4894L62.3641 10H55.4394L47 30.5181H52.8156L54.4251 26.4087H63.3378L64.9608 30.5181H76.1457V16.1569L81.1228 30.5181H85.7753ZM56.2374 21.7982L58.8747 15.083L61.4985 21.7982H56.2374Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmEx);
export default __webpack_public_path__ + "static/media/AmEx.07b2f7cb91685ac8dbf843215488a930.svg";
export { ForwardRef as ReactComponent };